import React, { useState, useEffect, useRef, useContext } from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText';
import Heading from 'src/components/Heading';
import Wave from 'src/utils/Wave';
import PricingPanel from '../PricingPanel'
import GetSettings from 'src/utils/GetSettings'
import { PageContext } from 'src/utils/context'  

const PricingWithoutToggle = ({ blok }) => {

    const { location } = useContext(PageContext)
    const settings = GetSettings(location)

    const active = blok.pricing
    const pricingProps = 
        blok.pricing === 'workplace' ? [settings.workplace, settings.workplace_features, settings.workplace_additional_features, settings.additional, settings.additional_title]
        : blok.pricing === 'education' ? [settings.education, settings.education_features, settings.education_additional_features]
        : blok.pricing === 'sports' ? [settings.sports, settings.sports_features, ""]
        : ''

    const [height, setHeight] = useState(0)
    const ref = useRef(null)

    const handleResize = () => {
        setHeight(ref.current.clientHeight)
    }
  
    // Get the height of the pricing panel so we can offset the height later
    useEffect(() => {
      window.addEventListener("resize", handleResize);
      handleResize()
      return () => window.removeEventListener("resize", handleResize);
    }, [])

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="overflow-hidden">
                <div className="py-16 lg:py-28 bg-teal relative">
                    <div className="max-w-7xl mx-auto px-6 pb-16 text-center flex flex-col justify-center items-center">
                        <Heading size="h2" className="text-white !mb-4 max-w-5xl">{blok.title}</Heading>
                        <p className="text-white lg:text-base text-sm max-w-2xl tracking-[-0.01em]">
                            <RichText>{blok.description}</RichText>
                        </p>
                    </div>
                    <div className="absolute w-full md:bottom-24 bottom-20 translate-y-full z-10" ref={ref}>
                        <PricingPanel id={active} pricing={pricingProps[0]} features={pricingProps[1]} additional_features={pricingProps[2]} additional={pricingProps[3]} additional_title={pricingProps[4]} active={active}/>
                    </div>
                </div>
                <Wave size="small" className="fill-teal"/>
                <div style={{height: height}}></div>
            </div>
        </SbEditable>  
    )
}

const ComponentToHide = () => (
  <div className="bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:py-36 py-16">
      <div className="flex flex-col items-center text-center mx-auto max-w-[840px] gap-4">
        <h3 className="text-3xl lg:text-4.5xl tracking-[-0.02em] font-semibold mb-3 bold-teal">
          <p><span className="">Pricing Plans</span></p>
        </h3>
        <div className="prose max-w-3xl mx-auto leading-6">
          <p>We offer flexible pricing plans designed to meet the unique needs of your organisation. Our goal is to provide comprehensive wellbeing solutions that are accessible and effective, ensuring you get the best value for your investment. </p>
          <p>For detailed pricing information and to discuss the best plan for your organisation, please reach out to our team.</p>
        </div>
        <a
          className="bg-teal hover:bg-darkteal inline-block text-white font-bold text-sm leading-4 rounded-md py-4 px-6 cursor-pointer duration-300 mt-6"
          href="/contact-us/"
        >
          Speak to us today
        </a>
      </div>
    </div>
  </div>
);

export default ComponentToHide;

//export default PricingWithoutToggle
